import { useRef, useState } from "react"
import { ChevronDown } from "lucide-react"
import { VscDashboard, VscSignOut } from "react-icons/vsc"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"

import useOnClickOutside from "../../../hooks/useOnClickOutside"
import { logout } from "../../../services/operations/authAPI"

export default function ProfileDropdown() {
  const { user } = useSelector((state) => state.profile)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useOnClickOutside(ref, () => setOpen(false))

  if (!user) return null

  return (
    <div className="relative">
      <button 
        className="flex items-center gap-2 p-2 rounded-xl hover:bg-white/10 transition-all duration-200" 
        onClick={() => setOpen(true)}
      >
        <img
          src={user?.image}
          alt={`profile-${user?.firstName}`}
          className="w-8 h-8 rounded-full object-cover border-2 border-white/20"
        />
        <ChevronDown className="h-4 w-4 text-slate-600" />
      </button>
      
      {open && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="absolute top-full right-0 mt-2 w-48 bg-white/90 backdrop-blur-sm rounded-xl shadow-xl border border-white/20 overflow-hidden z-50"
          ref={ref}
        >
          {user?.accountType === "SuperAdmin" && (
            <Link to="/dashboard/superadmin" onClick={() => setOpen(false)}>
              <div className="flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-all duration-200">
                <VscDashboard className="h-4 w-4" />
                <span className="font-medium">Dashboard</span>
              </div> 
            </Link>
          )}
          
          {user?.accountType === "Admin" && (
            <Link to="/dashboard/admin" onClick={() => setOpen(false)}>
              <div className="flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-all duration-200">
                <VscDashboard className="h-4 w-4" />
                <span className="font-medium">Dashboard</span>
              </div> 
            </Link>
          )}
          
          {user?.accountType === "Employee" && (
            <Link to="/dashboard/employee" onClick={() => setOpen(false)}>
              <div className="flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-blue-50 hover:text-blue-600 transition-all duration-200">
                <VscDashboard className="h-4 w-4" />
                <span className="font-medium">Dashboard</span>
              </div> 
            </Link>
          )}
          
          <div className="border-t border-white/20">
            <button
              onClick={() => {
                dispatch(logout(navigate))
                setOpen(false)
              }}
              className="w-full flex items-center gap-3 px-4 py-3 text-slate-700 hover:bg-red-50 hover:text-red-600 transition-all duration-200"
            >
              <VscSignOut className="h-4 w-4" />
              <span className="font-medium">Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  )
}